import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    label: "电影",
    desc: "全球佳片 · 影院热映",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20movie%20theater%20scene%20with%20a%20glowing%20projector%20beam%20and%20empty%20red%20seats%2C%20dramatic%20crimson%20lighting%2C%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20wide%20composition&width=800&height=600&seq=cherry-cat-movie&orientation=landscape",
  },
  {
    to: "/category/tv",
    label: "电视剧",
    desc: "热播剧集 · 追更不断",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20dark%20living%20room%20scene%20at%20night%20with%20a%20glowing%20television%20and%20warm%20ambient%20light%2C%20amber%20and%20charcoal%20tones%2C%20soft%20bokeh%2C%20intimate%20cinematic%20mood%2C%20wide%20composition&width=800&height=600&seq=cherry-cat-tv&orientation=landscape",
  },
  {
    to: "/category/variety",
    label: "综艺",
    desc: "欢乐综艺 · 全程高能",
    icon: "ri-mic-line",
    image:
      "https://readdy.ai/api/search-image?query=vibrant%20colorful%20variety%20show%20stage%20with%20confetti%20and%20bright%20gold%20spotlights%2C%20festive%20playful%20atmosphere%2C%20warm%20crimson%20and%20amber%20tones%2C%20dynamic%20composition%2C%20cinematic&width=800&height=600&seq=cherry-cat-variety&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-5">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative h-40 md:h-48 rounded-lg overflow-hidden border border-background-200 hover:border-primary-400 transition-colors cursor-pointer"
        >
          <img
            src={entry.image}
            alt={`${entry.label}分类`}
            title={`${entry.label} 影视分类`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/40 to-transparent"></div>
          <div className="relative h-full flex flex-col justify-end p-4 md:p-5 gap-1">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50 mb-1">
              <i className={`${entry.icon} text-lg`}></i>
            </span>
            <h3 className="font-heading font-black text-lg md:text-xl text-foreground-950">
              {entry.label}
            </h3>
            <p className="text-xs md:text-sm text-foreground-600">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}